import { type InferInsertModel, type InferSelectModel, relations } from 'drizzle-orm';
import { boolean, pgEnum, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import { softDelete } from '../columns/soft-delete';
import { accounts } from './accounts';
import { sessions } from './sessions';
export const userRoleEnum = pgEnum('user_role', ['admin', 'user']);
export type UserRole = (typeof userRoleEnum.enumValues)[number];

export const userRoleOptions: Array<{ value: UserRole; label: string }> = [
  { value: 'admin', label: 'Administrador' },
  { value: 'user', label: 'Usuário' },
];

export const users = pgTable('users', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  name: text('name').notNull(),
  email: text('email').notNull().unique(),
  emailVerified: boolean('email_verified').default(false).notNull(),
  image: text('image'),
  role: userRoleEnum('role').notNull().default('user'),
  isActive: boolean('is_active').default(true),
  needToChangePassword: boolean('need_to_change_password').notNull().default(false),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
  ...softDelete,
});

export const usersRelations = relations(users, ({ many }) => ({
  sessions: many(sessions),
  accounts: many(accounts),
}));

export type User = InferSelectModel<typeof users>;
export type CreateUserInput = InferInsertModel<typeof users>;
export type UpdateUserInput = Partial<CreateUserInput>;
